// extracted by mini-css-extract-plugin
export default {"companyContainer":"rO-z","companyImage":"sO-z","container":"tO-z","heading":"uO-z","darkText":"vO-z","smallHeading":"wO-z","darkBackground":"xO-z","whiteBackground":"yO-z"};